AgrimarketFactories.factory("modulesFactory", [
	function () {
		return {
			Modules: null
		};
	}]);